/*
  ULTREIA v16 — comportamiento base.
  Cuatro cosas chicas, sin dependencias:
    1 · apariciones al hacer scroll   ([data-u-aparece], [data-u-descubre])
    2 · "abierto ahora"               ([data-u-horario])
    3 · barra pegada en móvil         ([data-u-barra-pegada])
    4 · estado del encabezado         (body.u-arriba mientras no hubo scroll)
  Todo se vuelve a enganchar cuando el editor del tema recarga una sección.
*/
(function () {
  'use strict';

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  /* 1 · APARICIONES ─────────────────────────────────────────────────── */
  var visor = null;
  if ('IntersectionObserver' in window) {
    visor = new IntersectionObserver(
      function (entradas) {
        entradas.forEach(function (e) {
          if (e.isIntersecting) {
            e.target.classList.add('is-visto');
            visor.unobserve(e.target);
          }
        });
      },
      { rootMargin: '0px 0px 15% 0px', threshold: 0 } // aparece un poco antes de llegar: nunca se ve un hueco
    );
  }
  function escanear(raiz) {
    var nodos = (raiz || document).querySelectorAll('[data-u-aparece]:not(.is-visto), [data-u-descubre]:not(.is-visto)');
    for (var i = 0; i < nodos.length; i++) {
      if (!visor || reduce.matches) nodos[i].classList.add('is-visto');
      else visor.observe(nodos[i]);
    }
  }

  /* 2 · ABIERTO AHORA ───────────────────────────────────────────────────
     data-u-horario='{"abre":"13:00","cierra":"21:00","dias":[0,1,2,3,4,5,6]}'
     Los días van de 0 (domingo) a 6 (sábado). La hora es la de Uruguay,
     esté donde esté quien mira. */
  var DIAS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  // Crear un Intl.DateTimeFormat cuesta varios ms en un celular: uno solo, reusado.
  var formatoUy = null;
  function ahoraEnUruguay() {
    try {
      formatoUy = formatoUy || new Intl.DateTimeFormat('en-US', { timeZone: 'America/Montevideo', hour: '2-digit', minute: '2-digit', hourCycle: 'h23', weekday: 'short' });
      var partes = formatoUy.formatToParts(new Date());
      var m = {};
      partes.forEach(function (p) { m[p.type] = p.value; });
      var dia = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(m.weekday);
      return { dia: dia, min: parseInt(m.hour, 10) * 60 + parseInt(m.minute, 10) };
    } catch (e) {
      var d = new Date();
      return { dia: d.getDay(), min: d.getHours() * 60 + d.getMinutes() };
    }
  }
  function aMin(h) { var p = String(h).split(':'); return parseInt(p[0], 10) * 60 + parseInt(p[1] || '0', 10); }
  function hora(h) { var p = String(h).split(':'); return parseInt(p[0], 10) + (p[1] && p[1] !== '00' ? '.' + p[1] : '') + ' h'; }
  function pintarHorario(el, t) {
    var cfg;
    try { cfg = JSON.parse(el.getAttribute('data-u-horario')); } catch (e) { return; }
    if (!cfg || !cfg.abre || !cfg.cierra) return;
    var dias = cfg.dias || [0, 1, 2, 3, 4, 5, 6];
    var abre = aMin(cfg.abre), cierra = aMin(cfg.cierra);
    var abierto = dias.indexOf(t.dia) !== -1 && t.min >= abre && t.min < cierra;
    var texto;
    if (abierto) {
      texto = 'Abierto ahora · hasta las ' + hora(cfg.cierra);
    } else {
      var hoyAbre = dias.indexOf(t.dia) !== -1 && t.min < abre;
      if (hoyAbre) texto = 'Cerrado · abre hoy a las ' + hora(cfg.abre);
      else {
        for (var k = 1; k <= 7; k++) {
          var d = (t.dia + k) % 7;
          if (dias.indexOf(d) !== -1) { texto = 'Cerrado · abre ' + (k === 1 ? 'mañana' : 'el ' + DIAS[d]) + ' a las ' + hora(cfg.abre); break; }
        }
      }
    }
    if (!texto) return;
    var destino = el.querySelector('[data-u-horario-texto]') || el;
    destino.textContent = texto;
    el.classList.toggle('u-etiqueta--abierto', abierto);
    el.classList.toggle('u-etiqueta--cerrado', !abierto);
    el.hidden = false;
  }
  function horarios(raiz) {
    var nodos = (raiz || document).querySelectorAll('[data-u-horario]');
    if (!nodos.length) return;
    var t = ahoraEnUruguay(); // la misma hora para todas las etiquetas de la pasada
    for (var i = 0; i < nodos.length; i++) pintarHorario(nodos[i], t);
  }

  /* 3 · BARRA PEGADA ────────────────────────────────────────────────────
     <div class="u-barra-pegada" data-u-barra-pegada="#id-del-boton-real">
     Aparece cuando el botón real sale de la pantalla, y se va cuando
     vuelve a entrar o cuando se acerca el pie. */
  function barras(raiz) {
    if (!('IntersectionObserver' in window)) return;
    var nodos = (raiz || document).querySelectorAll('[data-u-barra-pegada]');
    for (var i = 0; i < nodos.length; i++) {
      (function (barra) {
        if (barra.dataset.uEnganchada) return;
        barra.dataset.uEnganchada = '1';
        var objetivo = document.querySelector(barra.getAttribute('data-u-barra-pegada'));
        var pie = document.querySelector('.u-pie, footer');
        if (!objetivo) return;
        var fuera = false, pieVisible = false;
        function actualizar() { barra.classList.toggle('is-visible', fuera && !pieVisible); barra.setAttribute('aria-hidden', fuera && !pieVisible ? 'false' : 'true'); }
        new IntersectionObserver(function (e) { fuera = !e[0].isIntersecting && e[0].boundingClientRect.top < 0; actualizar(); }).observe(objetivo);
        if (pie) new IntersectionObserver(function (e) { pieVisible = e[0].isIntersecting; actualizar(); }).observe(pie);
      })(nodos[i]);
    }
  }

  /* 4 · ENCABEZADO ──────────────────────────────────────────────────── */
  var arriba = null, pendienteScroll = false;
  function estadoArriba() {
    pendienteScroll = false;
    var a = window.scrollY < 8;
    if (a !== arriba) { arriba = a; document.body.classList.toggle('u-arriba', a); }
  }
  function alScroll() {
    if (pendienteScroll) return;
    pendienteScroll = true;
    requestAnimationFrame(estadoArriba);
  }

  /* ARRANQUE ────────────────────────────────────────────────────────── */
  function arrancar(raiz) { escanear(raiz); horarios(raiz); barras(raiz); }

  // Lo que llega después (filtros de colección, carrito, recomendaciones):
  // se miran solo los nodos agregados, y solo si traen algo que aparece.
  // Antes cualquier cambio del DOM (apps, analítica, la barra de vista
  // previa) disparaba un barrido del documento entero.
  var SELECTOR = '[data-u-aparece], [data-u-descubre]';
  var nuevos = [];
  var pendiente = false;
  function vaciar() {
    pendiente = false;
    var lista = nuevos; nuevos = [];
    for (var i = 0; i < lista.length; i++) if (lista[i].isConnected) escanear(lista[i].parentNode || lista[i]);
  }
  if ('MutationObserver' in window) {
    new MutationObserver(function (cambios) {
      for (var i = 0; i < cambios.length; i++) {
        var agregados = cambios[i].addedNodes;
        for (var j = 0; j < agregados.length; j++) {
          var n = agregados[j];
          if (n.nodeType !== 1) continue;
          if ((n.matches && n.matches(SELECTOR)) || (n.querySelector && n.querySelector(SELECTOR))) nuevos.push(n);
        }
      }
      if (nuevos.length && !pendiente) { pendiente = true; requestAnimationFrame(vaciar); }
    }).observe(document.body || document.documentElement, { childList: true, subtree: true });
  }

  function listo() {
    arrancar(document);
    estadoArriba();
    window.addEventListener('scroll', alScroll, { passive: true });
    setInterval(function () { horarios(document); }, 60000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', listo);
  else listo();
  document.addEventListener('shopify:section:load', function (e) { arrancar(e.target); });

  window.Ultreia = window.Ultreia || {};
  window.Ultreia.escanear = escanear;
})();
